import axios from 'axios'


export default {
  status: {
    PENDING: 'pending',
    SUCCESS: 'success',
    FAILURE: 'failure'
  },
  getTenantSettings() {
    return axios.get("/api/settings")
  },
  getResources () {
    return axios.get("/api/resources")
  },
  getBookingTypes () {
    return axios.get("/api/booking_types")
  },
  getAllScenarios (params) {
    return axios.get("/api/scenarios/all", { params: params })
  },
  getScenario (id) {
    return axios.get("/api/scenarios/" + id, { params: params })
  },
  getScenarios (params) {
    return axios.get("/api/scenarios", { params: params })
  },
  getAvailability (params) {
    return axios.get("/api/availability", { params: params })
  },
  getOpeningHours (params) {
    return axios.get("/api/opening_hours", { params: params })
  },
  getAddons (params) {
    return axios.get("/api/addons", { params: params })
  },
  getForm (params) {
    return axios.get("/api/forms", { params: params })
  },
  login (params) {
    return axios.post("/api/customer/login", params)
  },
  logout () {
    return axios.get("/api/customer/logout")
  },
  createOrder (params) {
    return axios.post("/api/order", params)
  },
  updateOrder (params) {
    return axios.put("/api/order", params)
  },
  getCountries () {
    return axios.get("/api/countries")
  },
  getSession () {
    return axios.get("/api/session")
  },
  cancelBooking () {
    return axios.post("/api/order/cancel_booking")
  },
  createCustomer (params) {
    return axios.post("/api/customer", params)
  },
  updateCustomer (params) {
    return axios.put("/api/customer", params)
  },
  getCustomer () {
    return axios.get("/api/customer")
  },
  createPayment (params) {
    return axios.post("/api/payments", params)
  },
  findAddress (postcode) {
    return axios.get("/api/addresses?postcode=" + encodeURIComponent(postcode))
  },
  resetPassword(params) {
    return axios.post("/api/password", params)
  },
  confirmPassword(params) {
    return axios.put("/api/password", params)
  }
}
